import React, { Component } from "react";
import { Route, Redirect } from "react-router-dom";
import AS from "./Service/Authentication";
import FireDetection from "../Layout/provider/FireDetection";
import { ROUTES } from "../../commons/constants/routes/routes";

class AuthenticatedRoute extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    if (AS.isUserLoggedIn()) {
      document.body.className = "";
      const { root } = this.props;
      const { params } = this.props.computedMatch;
      // switch (root) {
      //     case "plant":
      //         if (AS.isAuthPlant(params.plantId)) {
      //             return <Route {...this.props}/>
      //         } else {
      //             alert("권한이 없습니다.");
      //             return <Redirect to="/"/>;
      //         }
      //     default:
      //         return <Route {...this.props}/>
      // }
      return (
        <FireDetection>
          <Route {...this.props} />
        </FireDetection>
      );
    } else {
      return <Redirect to={ROUTES.LOGIN} />;
    }
  }
}

export default AuthenticatedRoute;
